import { useFormik } from 'formik';
import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { colors } from '../../../component/colors';
import { DropDownWithLabel } from '../../../component/dropDown';
import { ImagePicker } from '../../../component/imagePicker';
import { Input } from '../../../component/input';
import { AddModal } from '../../../component/modal';
import { useAddAgentMutation } from '../../../store/agent/api';
import { modules } from '../../../utils/module';
import { getLGA, states } from '../../../utils/nigeriaSates';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { addAgentValidation } from '../validation';

type IAddAgent = {
  show?: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
};
export const AddAgent: FC<IAddAgent> = ({ setShow }) => {
  const [addAgent, { isLoading }] = useAddAgentMutation();
  const handleFilePicked = (file: File[]) => {
    setFieldValue('file', file[0]);
  };
  const handleAddAgent = (values: {
    name: string;
    phone: string;
    module: string;
    lga: string;
    state: string;
    email: string;
    file: File | null;
  }) => {
    if (!values.file) {
      showErrorToast('image is required');
      return;
    }
    const formData = new FormData();
    formData.append('file', values.file);
    formData.append('name', values.name);
    formData.append('phone', values.phone);
    formData.append('email', values.email);
    formData.append(
      'module',
      values.module.toLocaleLowerCase().replace(' ', '-')
    );
    formData.append('state', values.state);
    formData.append('lga', values.lga);

    addAgent(formData)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setShow(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };

  const { values, errors, touched, setFieldValue, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        name: '',
        phone: '',
        module: '',
        lga: '',
        state: '',
        file: null,
        email: ''
      },
      validationSchema: addAgentValidation,
      onSubmit: handleAddAgent
    });
  return (
    <AddModal
      title="Add agent"
      disableBtn={isLoading}
      btnTxt={'Add agent'}
      btnClick={handleSubmit}
      closeModal={() => setShow(false)}
      isLoading={isLoading}
    >
      <Container>
        <Row>
          <CustomInput
            labelText="Fullname"
            value={values.name}
            onChange={handleChange('name')}
            errorMessage={touched.name ? errors.name : ''}
          />
          <CustomDropDown
            label="Module"
            value={values.module}
            onSelect={(item) => {
              setFieldValue('module', item);
            }}
            options={modules}
          />
        </Row>
        <Row>
          <CustomDropDown
            label="State"
            value={values.state}
            onSelect={(item) => {
              setFieldValue('state', item);
              setFieldValue('lga', '');
            }}
            options={states}
          />
          <CustomDropDown
            label="LGA"
            value={values.lga}
            onSelect={(item) => {
              setFieldValue('lga', item);
            }}
            options={getLGA(values.state)}
          />
        </Row>
        <Row>
          <CustomInput
            labelText="Mobile number"
            onChange={handleChange('phone')}
            value={values.phone}
            errorMessage={touched.phone ? errors.phone : ''}
          />
          <CustomInput
            labelText="Email address"
            type={'email'}
            onChange={handleChange('email')}
            value={values.email}
            errorMessage={touched.email ? errors.email : ''}
          />
        </Row>
        <CustomImageUpload multiple={false} onFilePicked={handleFilePicked} />
      </Container>
    </AddModal>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 40px;

  @media screen and (max-width: 500px) {
    height: calc(100vh - 225px);
    overflow-y: auto;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

const CustomInput = styled(Input)`
  flex: 0.46;
  color: ${colors.textDark};
  margin-bottom: 16px;
`;

const CustomDropDown = styled(DropDownWithLabel)`
  flex: 0.46;
  margin-bottom: 16px;
`;
const CustomImageUpload = styled(ImagePicker)``;
